// Smooth scroll utility function with header offset
const HEADER_OFFSET = 0;

export const scrollToSection = (sectionId) => {
  const element = document.getElementById(sectionId);
  if (element) {
    const elementPosition = element.getBoundingClientRect().top + window.scrollY;
    window.scrollTo({
      top: elementPosition - HEADER_OFFSET,
      behavior: 'smooth',
    });
  }
};

// Scroll to top utility function
export const scrollToTop = (behavior = 'smooth') => {
  window.scrollTo({
    top: 0,
    behavior: behavior
  });
};

export const scrollToTopInstant = () => {
  const html = document.documentElement;
  const body = document.body;

  if (!html || !body) {
    window.scrollTo(0, 0);
    return;
  }

  const previousHtmlScrollBehavior = html.style.scrollBehavior;
  const previousBodyScrollBehavior = body.style.scrollBehavior;

  html.style.scrollBehavior = 'auto';
  body.style.scrollBehavior = 'auto';
  window.scrollTo({ top: 0, left: 0, behavior: 'auto' });

  requestAnimationFrame(() => {
    html.style.scrollBehavior = previousHtmlScrollBehavior;
    body.style.scrollBehavior = previousBodyScrollBehavior;
  });
};

// Scroll to top with delay (useful for navigation)
export const scrollToTopWithDelay = (delay = 100, behavior = 'smooth') => {
  setTimeout(() => {
    scrollToTop(behavior);
  }, delay);
};
